// extracted by mini-css-extract-plugin
export default {"body":"style_body__ZOceq","innerContainer":"style_innerContainer__e-Rid"};